import React from "react";
import { AuthProvider } from "./context/providers/AuthContext";
import { FavoriteProvider } from "./context/providers/FavoriteContext";
import { LessonProvider } from "./context/providers/LessonContext";
import { InvitationProvider } from "./context/providers/InvitationContext";
import { SubscriptionProvider } from "./context/providers/SubscriptionContext";
const AppProvider = ({ children }) => {
	return (
		<AuthProvider>
			<LessonProvider>
				<InvitationProvider>
					<SubscriptionProvider>
						<FavoriteProvider>{children}</FavoriteProvider>
					</SubscriptionProvider>
				</InvitationProvider>
			</LessonProvider>
		</AuthProvider>
	);
};
export default AppProvider;
